import { render, staticRenderFns } from "./asset-status.vue?vue&type=template&id=608c1328&scoped=true&"
import script from "./asset-status.vue?vue&type=script&lang=js&"
export * from "./asset-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608c1328",
  null
  
)

export default component.exports